module.exports = __webpack_public_path__ + "media/images/lb/685-d9315252158eaba41574732ab7f05e24.svg";